/* Tiny URL router: gives every page a real address (/gallery, /painting/…)
   so links can be shared and the browser Back button works.
   The Studio keeps its own "#studio" address. */

const PATHS = {
  home: "/", gallery: "/gallery", prints: "/prints", about: "/about", contact: "/contact",
  wishlist: "/wishlist", cart: "/cart", checkout: "/checkout", confirm: "/confirmation",
};

export const pathFor = (page, id) => {
  if (page === "painting" && id) return `/painting/${encodeURIComponent(id)}`;
  if (page === "shopitem" && id) return `/prints/${encodeURIComponent(id)}`;
  if (page === "studio") return "/#studio";
  return PATHS[page] || "/";
};

export const parseLocation = () => {
  if (typeof window === "undefined") return { page: "home", id: null };
  if (window.location.hash === "#studio") return { page: "studio", id: null };
  const p = window.location.pathname.replace(/\/+$/, "") || "/";
  const m = p.match(/^\/painting\/(.+)$/);
  if (m) return { page: "painting", id: decodeURIComponent(m[1]) };
  /* /prints is the shop itself; /prints/<id> is one item in it. */
  const sm = p.match(/^\/prints\/(.+)$/);
  if (sm) return { page: "shopitem", id: decodeURIComponent(sm[1]) };
  const hit = Object.keys(PATHS).find((k) => PATHS[k] === p);
  return { page: hit || "home", id: null };
};
